import{isObject as o}from"@guildeducationinc/type-guards";var n=function(n){return o(n)&&(!("onScroll"in n)||"function"==typeof n.onScroll)&&(!("onScrollCapture"in n)||"function"==typeof n.onScrollCapture)};export{n as isScrollable};
//# sourceMappingURL=Scrollable.js.map
